import { HOP, HOP_FRAMES, HOME_Y, START_Y, WIDTH } from './constants';
import type { Direction, Frog } from './state';

export function beginHop(frog: Frog, direction: Direction): boolean {
  if (frog.hop) return false;
  const x = frog.x + (direction === 'left' ? -HOP : direction === 'right' ? HOP : 0);
  const y = frog.y + (direction === 'up' ? -HOP : direction === 'down' ? HOP : 0);
  frog.direction = direction;
  if (x < 6 || x > WIDTH - 6 || y > START_Y || y < HOME_Y) return false;
  frog.hop = { fromX: frog.x, fromY: frog.y, toX: x, toY: y, frame: 0 };
  frog.carrierId = null;
  return true;
}

export function advanceHop(frog: Frog): boolean {
  const hop = frog.hop;
  if (!hop) return false;
  hop.frame++;
  const t = Math.min(1, hop.frame / HOP_FRAMES);
  frog.x = hop.fromX + (hop.toX - hop.fromX) * t;
  frog.y = hop.fromY + (hop.toY - hop.fromY) * t;
  if (t < 1) return false;
  frog.hop = null;
  return true;
}
